import React, { useState, useEffect } from "react";

// ------------ Lib ------------------
import _ from "lodash";

// ------------ Components ------------
import Modal from 'react-bootstrap/Modal'
import {
    Row,
    Col,
    Button,
    Form,
    ListGroup,
    Table,
    Toast,
    Pagination,
    InputGroup,
    Image,
    FormControl,
    Spinner
} from "react-bootstrap";
import Loader from "../../components/Loader/Loader";
import EditIcon from '@material-ui/icons/Edit';
import { Tab, Tabs } from "react-bootstrap";
import { Info, Photo } from "@material-ui/icons";

// -------------- APIs ---------------
import API from "../../network/dashboardAPI";

// -------------- Style --------------
import styled from "styled-components";
import "react-datetime/css/react-datetime.css";
import UploadService from "../../services/FileUploadService";

const HelpPageWrapper = styled.div`
  position: relative;
  
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const labelStyle = {
    lineHeight: "2rem",
    minWidth: "140px"
}

const ReviewCard = (props) => {

    /*
    *   =================== States ==========================
    * */
    const [isRequesting, setIsRequesting] = useState(false);
    const [isRequestingUpsert, setIsRequestingUpsert] = useState(false);

    // table states
    const [dataList, setDataList] = useState([]);

    // filter states
    const [selectedStatus, setSelectedStatus] = useState('');

    // pagination states
    const [next, setNext] = useState(0);
    const [limit, setLimit] = useState(10);
    const [prev, setPrev] = useState(0);
    const [pager, setPager] = useState(1);
    const [dataCount, setDataCount] = useState(0);

    // modal states
    const [isShowModal, setIsShowModal] = useState(false);

    // form states
    const [validated, setValidated] = useState(false);
    const [dataToUpdate, setDataToUpdate] = useState({});
    const [name, setName] = useState("");
    const [name_km, setName_km] = useState("");
    const [comment, setComment] = useState("");
    const [comment_km, setComment_km] = useState("");
    const [dataId, setDataId] = useState("");
    const [dataNumber, setDataNumber] = useState("");
    const [isActive, setIsActive] = useState(false)
    const [formType, setFormType] = useState("ADD");

    // Form validation
    const [formError, setFormError] = useState({
        name: false,
        comment: false,
    });

    // toast states
    const [toastBgColor, setToastBgColor] = useState('bg-success');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("Delete successful");


    // confirm
    const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    const [dataToUpdateStatus, setDataToUpdateStatus] = useState({});
    const [isRequestingUpdateStatus, setIsRequestingUpdateStatus] = useState(false);

    /*
    *   =================== Methods =========================
    * */
    const getReviewList = async ($next) => {
        setIsRequesting(true);
        let params = { next: $next, limit }
        let query = {
            is_active: selectedStatus
        }


        await API.getReviewCard(params, query)
            .then(res => res.json())
            .then(res => {
                if (res.success === true && !_.isEmpty(res.data)) {
                    setDataList(res.data.list);
                    setDataCount(res.data.total);

                    if (res.data.next) {
                        setNext(res.data.next);
                    } else if (res.data.list.length) {
                        setNext($next > 0 ? next + res.data.list.length : res.data.list.length);
                    } else {
                        setNext(0);
                    }

                    setIsRequesting(false);
                } else {
                    setIsRequesting(false);
                }
            });
    }

    const updateReviewCard = async () => {
        setIsRequestingUpsert(true);
        let body = {
                id: dataId,
                name,
                name_km,
                comment,
                comment_km,
            }
        await API.UpdateReviewCard(body)
            .then((res) => res.json())
            .then((res) => {
                console.log(res);
                if (res.success === true) {
                    getReviewList(0)
                    handleShowToast("SUCCESS");
                    setIsRequestingUpsert(false);
                    handleCloseModal();
                } else {
                    handleShowToast("ERROR");
                    setIsRequestingUpsert(false);
                }
            });

    }

    const createReviewCard = async () => {
        setIsRequestingUpsert(true);
        let body = {
            is_active: 0,
            name,
            name_km,
            comment,
            comment_km,
        }
        await API.AddReviewCard(body)
            .then((res) => res.json())
            .then((res) => {
                console.log(res);
                if (res.success) {
                    handleShowToast("SUCCESS");
                    getReviewList(0);
                } else {
                    handleShowToast("ERROR");
                }

                // reset paginate
                resetPagination();

                setIsRequestingUpsert(false);
                handleCloseModal();
            })
    }

    const setFormData = (card) => {
        setDataToUpdate(card.is_active);
        setName(card.name);
        setName_km(card.name_km);
        setComment(card.comment);
        setComment_km(card.comment_km);
        setDataId(card.id);
        setIsActive(card.is_active);
    }

    const resetFormData = () => {
        setDataToUpdate({});
        setName("");
        setName_km("");
        setComment("");
        setComment_km("");
        setDataId("");
        setIsActive(false);
    }

    const resetPagination = () => {
        setPager(1);
        setPrev(0);
    }

    /*
    *   ==================== Compute Data ========================
    * */

    useEffect(() => {
        getReviewList(0);
    }, [selectedStatus]);


    /*
    *  ===================== Event handlers ======================
    * */

    const handleOpenModal = (formType, data) => {
        if (formType === "UPDATE") {
            setFormData(data);
        }

        setFormType(formType);
        setIsShowModal(true);
    }

    // modal event
    const handleCloseModal = () => {
        setIsShowModal(false);
        resetFormData();
        resetFormError();
    }

    const resetFormError = () => {
        setFormError({
            name: false,
            comment: false,
        })
    }

    const handleCommentChange = (e) => {
        setComment(e.target.value);
    }

    const handleComment_kmChange = (e) => {
        setComment_km(e.target.value);
    }

    const handleName = (e) => {
        setName(e.target.value);
    }
    const handleName_km = (e) => {
        setName_km(e.target.value);
    }


    const handleUpsertSlider = async () => {
        if (checkFormValidate()) {
            if (dataId) {
                await updateReviewCard();
            } else {
                await createReviewCard();
            }
        }
    }

    const checkFormValidate = () => {
        let tmpFormError = {
            name: false,
            comment: false,
        }

        if (!name) tmpFormError.name = true;
        if (!comment) tmpFormError.comment = true;

        setFormError(tmpFormError);

        return Object.values(tmpFormError).every(el => el === false);
    }


    // toast event
    const handleShowToast = (type) => {
        setShowToast(true);

        if (type === "SUCCESS") {
            setToastBgColor("bg-success");
            setToastMessage("Operation successful.");
        } else if (type === "ERROR") {
            setToastBgColor("bg-error");
            setToastMessage("Operation error.");
        }
    }

    // pagination handlers
    const handlePaginNext = () => {
        const { next, prev } = updatePaginationProps("NEXT");
        getReviewList(prev);
    };

    const handlePaginPrev = () => {
        const { pager, next, prev } = updatePaginationProps("PREV");
        getReviewList(prev);
    };

    const updatePaginationProps = (type) => {
        let tmpPager = pager + 1;
        if (type === "PREV") {
            tmpPager = pager - 1;
        }

        const tmpNext = limit * tmpPager;
        const tmpPrev = limit * tmpPager - limit;

        setPager(tmpPager);
        setPrev(tmpPrev);

        return { pager: tmpPager, next: tmpNext, prev: tmpPrev };
    };

    const handleCloseConfirmModal = () => {
        setIsShowConfirmModal(false);
        setIsRequestingUpdateStatus(false);
        setDataToUpdateStatus({});
    }

    const handleOpenConfirmModal = (data) => {
        setIsShowConfirmModal(true);
        setDataToUpdateStatus(data);
    }

    const handleSubmitDisActive = async () => {
        setIsRequestingUpdateStatus(true);
        
        let body = {
            id: dataToUpdateStatus.id,
            is_active: dataToUpdateStatus.is_active === 1 ? "0" : "1",
        }
        await API.UpdateReviewCard(body)
            .then(res => res.json())
            .then(res => {
                if (res.success === true && !_.isEmpty(res.data)) {
                    handleShowToast("SUCCESS");
                    handleCloseConfirmModal();
                    getReviewList(0);

                    // reset paginate
                    resetPagination();
                } else {
                    handleShowToast("ERROR");
                    handleCloseConfirmModal();
                }
            });

    }

    const handleChangeStatusFilter = (e) => {
        // reset pagination
        resetPagination();
        setSelectedStatus(e.target.value);
    }

    /*
    *   ==================== Functional Components ================
    * */

    const tableContent = (
        dataList.length > 0 ? dataList.map((data, index) => (
            <tr key={index}>
                <td className="text-center">{data.id}</td>
                <td>{data.name}</td>
                <td>{data.comment}</td>
                <td className="text-center">
                    <Button variant={data.is_active === 1 ? "success" : "danger"}
                        style={{
                            width: "12vh",
                            border: "none",
                            outline: "none",
                            boxShadow: "none"
                        }}
                        onClick={() => handleOpenConfirmModal(data)}
                    >
                        {data.is_active === 1 ? "Active" : "Inactive"}
                    </Button>
                </td>
                <td className="text-center">
                    <Button variant="info" onClick={() => handleOpenModal("UPDATE", data)}>
                        <EditIcon></EditIcon>
                    </Button>
                </td>
            </tr>
        )) :
            <tr>
                <td colSpan={5} className="text-center">No data</td>
            </tr>
    )

    let pageItems = [
        <Pagination.Item disabled={next <= limit} key={0} onClick={handlePaginPrev}>
            Prev
        </Pagination.Item>,
        <Form.Group key={1} controlId="formGridPagination">
            <InputGroup>
                <InputGroup.Prepend>
                    <InputGroup.Text>{`${next} / ${dataCount}`}</InputGroup.Text>
                </InputGroup.Prepend>
            </InputGroup>
        </Form.Group>,
        <Pagination.Item
            disabled={next === dataCount}
            key={2}
            onClick={handlePaginNext}
        >
            Next
        </Pagination.Item>,
    ];
    const PaginationBasic = () => (
        <div className="d-flex justify-content-center">
            <Pagination>{pageItems}</Pagination>
        </div>
    );


    return (
        <HelpPageWrapper>
            <SettingsFormContent>
                <div>
                    <Row className="mb-2">
                        <Col sm={8}>
                            <Button variant="success" disabled={isRequesting || isRequestingUpsert} onClick={() => handleOpenModal("ADD", null)}>
                                Add Card
                            </Button>
                        </Col>

                        <Col sm={4} className="d-flex justify-content-end">
                            <Form.Label style={labelStyle}>Filter status: </Form.Label>&nbsp;&nbsp;
                            <Form.Control
                                as="select"
                                onChange={(e) => handleChangeStatusFilter(e)}
                                value={selectedStatus}
                            >
                                <option value={""}>All status</option>
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </Form.Control>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            {isRequesting ?
                                <div style={{ position: "fixed", left: "55%", top: "35%" }}><Loader color="#9cc54b" h="100" />
                                </div> :
                                [
                                    <Table striped bordered hover key={1}>
                                        <thead>
                                            <tr>
                                                <th className="text-center">ID</th>
                                                <th>Name</th>
                                                <th>comment</th>
                                                <th className="text-center">Status</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableContent}
                                        </tbody>
                                    </Table>,
                                    <PaginationBasic key={2}></PaginationBasic>
                                ]
                            }
                        </Col>
                    </Row>
                </div>
            </SettingsFormContent>

            <Modal
                show={isShowModal}
                onHide={handleCloseModal}
                aria-labelledby="contained-modal-comment-vcenter"
                size="md"
                animation={true}
                centered
            >
                <Form
                    noValidate
                    validated={validated}
                    autoComplete="false"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{formType === "ADD" ? "Add" : "Update"} Card Review</Modal.Title>
                    </Modal.Header>
                    <Modal.Body key="modalBody">
                        <Row>
                            <Col sm={12}>
                                <Form.Group controlId="formTitle">
                                    <Form.Label>Name*</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={name}
                                        placeholder="Name"
                                        disabled={isRequestingUpsert}
                                        isInvalid={formError.name}
                                        required
                                        onChange={(e) => handleName(e)}
                                    />
                                    <Form.Control.Feedback type="invalid">Name is required.</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formTitle">
                                    <Form.Label>Name_km*</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={name_km}
                                        placeholder="Name_km"
                                        disabled={isRequestingUpsert}
                                        required
                                        onChange={(e) => handleName_km(e)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formTitle">
                                    <Form.Label>comment*</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={6}
                                        disabled={isRequestingUpsert}
                                        value={comment}
                                        isInvalid={formError.comment}
                                        onChange={(e) => handleCommentChange(e)}
                                    />
                                    <Form.Control.Feedback type="invalid">comment is required.</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formTitle">
                                    <Form.Label>comment_km*</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={6}
                                        disabled={isRequestingUpsert}
                                        value={comment_km}
                                        onChange={(e) => handleComment_kmChange(e)}
                                    />
                                </Form.Group>

                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button disabled={isRequestingUpsert} variant="primary"
                            onClick={() => handleUpsertSlider()}>
                            {
                                isRequestingUpsert ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    null
                            }

                            <span className="pl-2 pr-2">
                                {formType === "ADD" ? "Add" : "Update"}
                            </span>
                        </Button>

                        <Button
                            disabled={isRequestingUpsert}
                            variant="secondary"
                            onClick={handleCloseModal}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/*
                ================ Confirm active / inactive
            */}
            <Modal show={isShowConfirmModal}
                animation={true}
                onHide={handleCloseConfirmModal}
                aria-labelledby="contained-modal-comment-vcenter"
                size="xs"
                centered
            >
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title className="text-white">Warning</Modal.Title>
                </Modal.Header>
                <Modal.Body key="modalBody" className="text-center">
                    <Form.Label>Do you want to {dataToUpdateStatus.is_active ? "inactive" : "active"} this Card?</Form.Label>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button variant="danger" disabled={isRequestingUpdateStatus} onClick={handleSubmitDisActive}>
                        {
                            isRequestingUpsert ?
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> :
                                null
                        }

                        <span className="pl-2 pr-2">Ok</span>
                    </Button>

                    <Button variant="secondary" disabled={isRequestingUpdateStatus} onClick={handleCloseConfirmModal}>Cancel</Button>
                </Modal.Footer>
            </Modal>


            <Toast className={toastBgColor}
                onClose={() => setShowToast(false)}
                show={showToast}
                delay={3000}
                autohide
                style={{
                    position: 'fixed',
                    top: 70,
                    right: 35,
                    zIndex: 1041,
                    width: "300px"
                }}
            >
                <Toast.Header>
                    <strong className="mr-auto m-3">{toastMessage}</strong>
                </Toast.Header>
            </Toast>
        </HelpPageWrapper>

    );
}

// Style
const ImageLoading = styled.div`
  position: relative;
  
  .hide {display: none;}
  .isLoading {
    position: absolute;
    background-color: rgb(255,255,255,0.4);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const SettingsFormContent = styled.div`
  margin-bottom: 50px;

  &:last-child {
    margin-bottom: 0;
  }
  .tabProfile {
    border-bottom: 1px solid #ddd !important;
    justify-content: center;
    margin-bottom: 20px;
  }
`;


export default ReviewCard;
